<template>
  <nav class="gnb" v-show="closeResult">
    <article class="gnbHead">
      <h1 class="logo">
        <a href="/Main" class=""
          ><div class="logoImg"></div>
          통합주차포털</a
        >
      </h1>
      <button type="button" class="btnClose" @click="btnClose"><span class="hidden">닫기</span></button>
    </article>
    <article class="gnbCont">
      <div class="inner">
        <!-- Logout -->
        <ul v-if="isLogin">
          <div class="btnArea">
            <button type="button" class="btn dkBlue" @click="actionLogout">로그아웃</button>
            <button type="button" class="btn mint" @click="actionRouter('mypagemain')">회원정보</button>
          </div>
        </ul>
        <!-- Login -->
        <ul v-else>
          <div class="btnArea">
            <button type="button" class="btn dkBlue" @click="actionRouter('loginmain')">로그인</button>
            <button type="button" class="btn mint" @click="actionRouter('join')">회원가입</button>
          </div>
        </ul>
        <ul class="depth01" @click="accordion">
          <li>
            <p class="tit" @click="park">공영주차장</p>
            <ul class="depth02" v-show="parking">
              <li class="sub-contain">
                <p @click="parkSearch">노외주차장 검색</p>
                <ul class="depth03" v-show="psearch">
                  <li @click="btnClose">
                    <router-link to="/map" title="지도검색">지도검색</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/list" title="주소검색">주소검색</router-link>
                  </li>
                </ul>
              </li>
              <li @click="btnClose">
                <router-link to="/parkfeeinformation" title="주차장 이용안내">주차장 이용안내</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/parkfeereduction" title="주차장 요금안내">주차장 요금안내</router-link>
              </li>
            </ul>
          </li>
          <li>
            <p class="tit" @click="prepay">주차요금 정산</p>
            <ul class="depth02" v-show="prepayment">
              <li class="sub-contain">
                <!-- <p @click="payment">요금사전결제</p>
                <ul class="depth03" v-show="advancePayment">
                  <li @click="btnClose">
                    <router-link to="/prepaymentinfo" title="사전결제 안내">사전결제 안내</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/lookup" title="요금 조회/결제">요금 조회 &#47;결제</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/advancepayment" title="주차요금 간편조회">주차요금 간편조회</router-link>
                  </li>
                </ul> -->
              </li>
              <li class="sub-contain">
                <p @click="unpaidFee">미납주차요금</p>
                <ul class="depth03" v-show="unpaid">
                  <li @click="btnClose">
                    <router-link to="/unpaidinfo" title="미납요금 납부안내">미납요금 납부안내</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/lookupunpaid" title="미납요금 조회/결제"
                      >미납요금 조회/결제</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <p class="tit" @click="parkService">주차서비스</p>
            <ul class="depth02" v-show="service">
              <li class="sub-contain" v-if="memberType !== 'BSN' || idAdmin">
                <p @click="period">공영주차 정기권</p>
                <ul class="depth03" v-show="parkPeriod">
                  <li @click="btnClose">
                    <router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link>
                  </li>
                </ul>
              </li>
              <li class="sub-contain" v-if="memberType !== 'USR' || idAdmin">
                <p @click="discount">웹 선불권</p>
                <ul class="depth03" v-show="parkDiscount">
                  <li @click="btnClose">
                    <router-link to="/webdiscountcharge" title="웹 선불권 충전">웹 선불권 충전</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/webdiscountuse" title="웹 선불권 적용">웹 선불권 적용</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <p class="tit" @click="info">정보마당</p>
            <ul class="depth02" v-show="board">
              <li @click="btnClose">
                <router-link to="/noticelist" title="공지사항">공지사항</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/faqview" title="자주묻는 질문">자주묻는 질문</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link>
              </li>
            </ul>
          </li>
          <li v-if="isLogin">
            <p class="tit" @click="myPage">마이페이지</p>
            <ul class="depth02" v-show="mypage">
              <li @click="btnClose">
                <router-link to="/mypagemain" title="회원정보">회원정보</router-link>
              </li>
              <li @click="btnClose" v-if="memberType !== 'BSN' || idAdmin">
                <router-link to="/mypageprepayment" title="서비스 이용내역">서비스 이용내역</router-link>
              </li>
              <li @click="btnClose" v-if="memberType !== 'USR' || idAdmin">
                <router-link to="/mypagediscountpayment" title="웹 선불권 이용내역">웹 선불권 이용내역</router-link>
              </li>
            </ul>
          </li>
          <li v-if="isLogin && idAdmin">
            <p class="tit" @click="manage">관리자메뉴</p>
            <ul class="depth02" v-show="management">
              <li class="sub-contain">
                <p @click="memManage">회원관리</p>
                <ul class="depth03" v-show="memberManage">
                  <li @click="btnClose">
                    <router-link to="/generalmembership" title="정기권 안내">일반회원</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/businessmembership" title="정기권 신청">사업자회원</router-link>
                  </li>
                </ul>
              </li>
              <li class="sub-contain">
                <p @click="discountCar">할인차량관리</p>
                <ul class="depth03" v-show="discountCarManage">
                  <li @click="btnClose">
                    <router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link>
                  </li>
                </ul>
              </li>
              <li @click="btnClose">
                <router-link to="/periodparking" title="정기권 주차장 관리">정기권 주차장 관리</router-link>
              </li>
              <li class="sub-contain">
                <p @click="notice">게시판관리</p>
                <ul class="depth03" v-show="noticeManage">
                  <li @click="btnClose">
                    <router-link to="/noticemanagement" title="공지사항 관리">공지사항 관리</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/faqmanagement" title="자주묻는질문 관리">자주묻는질문 관리</router-link>
                  </li>
                </ul>
              </li>
              <li class="sub-contain">
                <p @click="popup">팝업/배너관리</p>
                <ul class="depth03" v-show="popupManage">
                  <li @click="btnClose">
                    <router-link to="/popuplist" title="팝업관리">팝업관리</router-link>
                  </li>
                  <li @click="btnClose">
                    <router-link to="/bannerlist" title="배너관리">배너관리</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li v-if="isLogin && idAdmin">
            <p class="tit" @click="sysManage">시스템관리</p>
            <ul class="depth02" v-show="sysManagement">
              <li @click="btnClose">
                <router-link to="/usermanagement" title="사용자관리">사용자관리</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/teamlist" title="팀관리">팀관리</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/departmentlist" title="부서관리">부서관리</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/menulist" title="메뉴관리">메뉴관리</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link>
              </li>
              <li @click="btnClose">
                <router-link to="/accessinfo" title="접속정보">접속정보</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </article>
  </nav>
</template>

<script>
import axios from 'axios';
import { router } from '@/routers/router';

export default {
  data() {
    return {
      parking: false,
      psearch: false,
      prepayment: false,
      advancePayment: false,
      unpaid: false,
      reduction: false,
      service: false,
      parkPeriod: false,
      parkDiscount: false,
      board: false,
      mypage: false,
      closeResult: false,
      close: false,

      management: false,
      memberManage: false,
      discountCarManage: false,
      noticeManage: false,
      popupManage: false,
      sysManagement: false,
    };
  },

  created() {
    window.addEventListener('resize', this.resizeBrowserHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeBrowserHandler);
  },

  computed: {
    memberType() {
      return this.$store.state.empDiv;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    businessLogin() {
      return this.$store.state.empDiv === 'BSN';
    },
    idAdmin() {
      return this.$store.state.authorCode === 'ROLE_ADMIN';
    },
    empNm() {
      return this.$store.state.empNm;
    },
  },

  methods: {
    router() {
      return router;
    },
    park() {
      this.parking = !this.parking;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = false;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = false;
    },

    parkSearch() {
      this.parking = true;
      this.psearch = !this.psearch;
    },

    prepay() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = !this.prepayment;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = false;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = false;
    },

    payment() {
      this.prepayment = true;
      (this.unpaid = false), (this.advancePayment = !this.advancePayment);
    },

    unpaidFee() {
      this.prepayment = true;
      (this.advancePayment = false), (this.unpaid = !this.unpaid);
    },

    fareReduce() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = !this.reduction;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = false;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = false;
    },

    parkService() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = !this.service;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = false;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = false;
    },

    period() {
      this.service = true;
      (this.parkDiscount = false), (this.parkPeriod = !this.parkPeriod);
    },

    discount() {
      this.service = true;
      (this.parkPeriod = false), (this.parkDiscount = !this.parkDiscount);
    },

    info() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = !this.board;
      this.mypage = false;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = false;
    },

    myPage() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = !this.mypage;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = false;
    },

    manage() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = false;
      this.management = !this.management;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = false;
    },

    memManage() {
      this.management = true;
      (this.memberManage = !this.memberManage),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
    },

    discountCar() {
      this.management = true;
      (this.memberManage = false),
        (this.discountCarManage = !this.discountCarManage),
        (this.noticeManage = false),
        (this.popupManage = false);
    },

    notice() {
      this.management = true;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = !this.noticeManage),
        (this.popupManage = false);
    },

    popup() {
      this.management = true;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = !this.popupManage);
    },

    sysManage() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = false;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = !this.sysManagement;
    },

    btnClose() {
      this.parking = false;
      this.psearch = false;
      this.prepayment = false;
      (this.advancePayment = false), (this.unpaid = false);
      this.reduction = false;
      this.service = false;
      (this.parkDiscount = false), (this.parkPeriod = false);
      this.board = false;
      this.mypage = false;
      this.management = false;
      (this.memberManage = false),
        (this.discountCarManage = false),
        (this.noticeManage = false),
        (this.popupManage = false);
      this.sysManagement = !this.sysManagement;
      this.$emit('closeResult');

      const content = document.querySelectorAll('.depth01 li');
      const subList = document.querySelectorAll('.tit');
      [].forEach.call(subList, function (a) {
        a.classList.remove('active');
      });
      [].forEach.call(content, function (a) {
        a.classList.remove('show');
      });
    },

    accordion(e) {
      const content = document.querySelectorAll('.depth01 li');
      const subList = document.querySelectorAll('.tit');
      let isShow = e.target.parentNode.classList.contains('show');
      if (isShow) {
        e.target.parentNode.classList.remove('show');
        e.target.parentNode.childNodes.forEach(ele => {
          if (ele.tagName === 'P') {
            ele.classList.remove('active');
          }
        });
      } else {
        content.forEach(ele => {
          ele.classList.remove('show');
        });
        e.target.parentNode.classList.add('show');

        subList.forEach(ele => {
          ele.classList.remove('active');
        });

        //  let index = e.target.parentNode.dataset.num;
        if (e.target.classList.contains('tit')) {
          e.target.classList.add('active');
        }
      }
      if (e.target.parentNode.classList.contains('sub-contain')) {
        subList[1].classList.add('active');
      }
    },

    resizeBrowserHandler(e) {
      // mobile screen
      if (e.target.innerWidth > 1024) {
        this.prepayment = false;
        this.reduction = false;
        this.service = false;
        this.board = false;
        this.mypage = false;
        const subList = document.querySelectorAll('.tit');
        [].forEach.call(subList, function (a) {
          a.classList.remove('active');
        });
        this.$emit('closeResult');
      }
    },

    modalCloseBtn(e) {
      switch (e) {
        case 'emailModalShow':
          this.emailModalShow = false;
          break;
        case 'personalModalShow':
          this.personalModalShow = false;
          break;
        case 'copyrightModalShow':
          this.copyrightModalShow = false;
          break;
      }
    },

    modalShowBtn(e) {
      switch (e) {
        case 'emailModalShow':
          this.emailModalShow = true;
          break;
        case 'personalModalShow':
          this.personalModalShow = true;
          break;
        case 'copyrightModalShow':
          this.copyrightModalShow = true;
          break;
      }
    },

    actionLogout() {
      axios
        .post('/api/actionLogout.json')
        .then(response => {
          alert('로그아웃 하였습니다.');
          this.$store.dispatch('logout', null);
          this.$router.push('/loginmain');
        })
        .catch(function (error) {});
      this.btnClose();
    },

    actionRouter(url) {
      this.$router.push('/' + url);
      this.btnClose();
    },
  },
};
</script>

<style></style>
